import { render, staticRenderFns } from "./projectPermissions.vue?vue&type=template&id=8b245dea&scoped=true&"
import script from "./projectPermissions.vue?vue&type=script&lang=js&"
export * from "./projectPermissions.vue?vue&type=script&lang=js&"
import style0 from "./projectPermissions.vue?vue&type=style&index=0&id=8b245dea&prod&lang=less&scoped=true&"
import style1 from "./projectPermissions.vue?vue&type=style&index=1&id=8b245dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b245dea",
  null
  
)

export default component.exports